import { render, staticRenderFns } from "./NgChips.vue?vue&type=template&id=a85dc9a2"
import script from "./NgChips.vue?vue&type=script&lang=js"
export * from "./NgChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports